var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNotificationIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Notification Icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Notification-Icon",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.0161152,1 C13.129585,1 14.0322305,1.8954305 14.0322305,3 C14.0322305,3.04414234 14.0307889,3.08795068 14.0279499,3.1313812 C17.5790232,3.65516648 19.3547064,5.7446989 19.3547064,9.4 L19.3547064,14.3821387 C19.3547064,15.9665672 20.3097697,17.3947622 21.7740447,18 C22.0393039,18.1096412 22.1654572,18.4135581 22.055816,18.6788173 C21.9754668,18.8732092 21.7858647,19 21.5755217,19 L2.6178613,19 C2.33083577,19 2.09815561,18.7673198 2.09815561,18.4802943 C2.09815561,18.2699512 2.2249464,18.0803492 2.4193383,18 C3.88361322,17.3947622 4.83867659,15.9665672 4.83867659,14.3821387 L4.83867659,9.4 C4.83867659,5.79982571 6.56120433,3.71854848 10.0062598,3.15616831 C10.0020481,3.10475531 10,3.05261492 10,3 C10,1.8954305 10.9026455,1 12.0161152,1 Z",
    id: "Combined-Shape",
    stroke: "#727272",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12,23.5 C15,23.5 15,20.5 15,20.5 C15,20.5 9,20.5 9,20.5 C9,20.5 9,23.5 12,23.5 Z",
    id: "Oval",
    fill: "#727272"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationIcon);
export default __webpack_public_path__ + "static/media/Notification-Icon.4ceaf825ad726b5d488fdb25a6532011.svg";
export { ForwardRef as ReactComponent };